/* =====================================================================
   v2 — Keşfet: yetenek şeması + "Deneyin" penceresi
   Kaynak: fmk/bigibuddy-v2.html · Bkz. brief §5 ve §6

   - Çember düğümleri açıya göre JS ile konumlanır (R = size * 0.35,
     cihaz yarıçapı size * 0.185). Her boyut değişiminde yeniden hesaplanır.
   - Otomatik tur: kullanıcı dokunana kadar imleç yetenekleri SIRAYLA gezer.
     Bölüm ekrandan çıkarsa durur, dönünce kaldığı yerden devam eder.
   - Tam ekran: Fullscreen API; desteklenmiyorsa (iOS Safari) CSS kaplaması.
   ===================================================================== */
(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(section) {
    if (!section || section.dataset.v2OrbitReady === 'true') return;

    var dataEl = section.querySelector('[data-v2-orbit-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    /* Yetenekler artık tek bir JSON yükünden değil, her biri kendi verisini
       data-* ile basan tema bloklarından (blocks/v2-capability) okunuyor.
       "Deneyin" penceresinin içeriği de o bloğun alt bloklarınca basılmış
       hazır işaretleme: burada üretmiyoruz, kopyalayıp bağlıyoruz. */
    var items = Array.prototype.slice
      .call(section.querySelectorAll('[data-v2-cap]'))
      .map(function (el) {
        var d = el.dataset;
        var iconEl = el.querySelector('[data-v2-cap-icon]');
        var demoEl = el.querySelector('[data-v2-cap-demo]');
        return {
          kind: d.kind || 'builtin',
          name: d.name || '',
          short: d.short || '',
          subtitle: d.subtitle || '',
          age: d.age || '',
          angle: parseFloat(d.angle) || 0,
          description: d.description || '',
          gain: d.gain || '',
          statValue: d.statValue || '',
          statLabel: d.statLabel || '',
          footnote: d.footnote || '',
          link: d.link || '',
          linkLabel: d.linkLabel || '',
          el: el,
          iconSvg: iconEl ? iconEl.innerHTML : '',
          showDevice: d.showDevice !== 'false',
          demoHtml: demoEl && demoEl.children.length ? demoEl.innerHTML : ''
        };
      })
      .filter(function (item) {
        return item.name;
      });
    if (!items.length) return;


    var t = data.i18n || {};
    var stage = section.querySelector('[data-v2-orbit]');
    var lines = section.querySelector('[data-v2-orbit-lines]');
    var panel = section.querySelector('[data-v2-orbit-detail]');
    var cursor = section.querySelector('[data-v2-orbit-cursor]');
    var stageWrap = section.querySelector('[data-v2-orbit-stage]');
    if (!stage || !lines || !panel) return;

    section.dataset.v2OrbitReady = 'true';

    /* ---------------- Düğümler ---------------- */
    var nodes = [];
    var touched = false;
    var armed = true;
    var playing = false;
    var timers = [];
    var tourIdx = -1;

    function at(ms, fn) {
      timers.push(setTimeout(fn, ms));
    }

    function stopTour() {
      timers.forEach(clearTimeout);
      timers = [];
      playing = false;
      if (cursor) {
        cursor.classList.remove('is-show', 'is-tap', 'is-ready');
        cursor.style.transform = '';
      }
    }

    items.forEach(function (item, index) {
      var b = document.createElement('button');
      b.type = 'button';
      b.addEventListener('click', function () {
        stopTour();
        touched = true; /* tur bir daha başlamaz */
        armed = false;
        select(index);
        revealPanel();
      });

      /* Ayrı satılanlar da çemberde — ama DIŞ, kesikli, okra halkada.
         Eskiden diyagramın altındaki şeritteydiler ve ekosistemin cihazın
         etrafında büyüdüğü okunmuyordu. */
      var isEco = item.kind === 'buddy';
      b.className = 'v2-orbit__node' + (isEco ? ' is-eco' : '');
      b.setAttribute('aria-label', isEco ? item.name + ' — ' + (t.separatelySold || '') : item.name);
      b.innerHTML = '<span class="v2-orbit__node-lbl"></span>';
      b.firstChild.textContent = item.short || item.name;
      stage.appendChild(b);
      nodes.push(b);
    });

    /* ---------------- Bilgi kartı ---------------- */
    function select(index) {
      var item = items[index];
      if (!item) return;

      nodes.forEach(function (n, k) {
        n.classList.toggle('is-on', k === index);
      });

      var eco = item.kind === 'buddy';
      var html = '';

      html +=
        '<div class="v2-od__top">' +
        '<span class="v2-od__ico' +
        (eco ? ' eco' : '') +
        '">' +
        (item.iconSvg || '') +
        '</span>' +
        '<span><span class="v2-od__name">' +
        esc(item.name) +
        '</span>' +
        (item.subtitle ? '<span class="v2-od__sub">' + esc(item.subtitle) + '</span>' : '') +
        '</span>' +
        /* "Deneyin" butonu başlık satırında ve sağda: rozet satırının içinde
           gözden kaçıyordu, karta bakan ilk anda görsün. */
        (item.demoHtml ? '<button class="v2-od__try' +
          (eco ? ' eco' : '') +
          '" type="button" data-v2-demo="' +
          index +
          '">' +
          '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">' +
          '<path d="M12 3v3M12 18v3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M3 12h3M18 12h3M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/>' +
          '<circle cx="12" cy="12" r="3.2"/></svg>' +
          esc(t.tryIt) +
          '</button>' : '') +
        '</div>';

      if (item.statValue) {
        html +=
          '<div class="fig v2-od__fig"><b>' +
          esc(item.statValue) +
          '</b><span>' +
          esc(item.statLabel) +
          '</span></div>';
      }

      html += '<div class="v2-od__pills">';
      html += eco
        ? '<span class="pill pill-eco">' + esc(t.separatelySold) + '</span>'
        : '<span class="pill pill-inc">' + esc(t.builtIn) + '</span>';
      if (item.age) html += '<span class="pill pill-age">' + esc(item.age) + '</span>';
      html += '</div>';

      if (item.description) html += '<p>' + esc(item.description) + '</p>';

      if (item.gain) {
        html +=
          '<div class="v2-od__win"><span class="v2-od__win-h">' +
          esc(t.gainHeading) +
          '</span>' +
          esc(item.gain) +
          '</div>';
      }

      /* Dipnot: ücretsiz abonelik paketinin o yetenekteki sınırı gibi, kartın
         iddiasını sınırlayan küçük bilgi. Kazanımın altında, bağlantının
         üstünde durur — okunur ama vaadi bastırmaz. */
      if (item.footnote) {
        html +=
          /* <p> değil <div>: `.v2 p` ve `.v2-orbit__detail p` kuralları
             daha yüksek özgüllükte, dipnotun küçük punto ve boşluğunu ezerdi. */
          '<div class="v2-od__note">' +
          '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">' +
          '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.6v.1"/></svg>' +
          '<span>' +
          esc(item.footnote) +
          '</span></div>';
      }

      if (item.link) {
        html +=
          '<a class="v2-od__link" href="' +
          esc(item.link) +
          '">' +
          esc(item.linkLabel || '') +
          '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" style="width:15px;height:15px;"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      }

      panel.innerHTML = html;

      /* Giriş animasyonunu yeniden tetikle: sınıfı kaldır, reflow, geri ekle */
      panel.classList.remove('is-swap');
      void panel.offsetWidth;
      panel.classList.add('is-swap');
    }

    /* Kart ekranda HIC gorunmuyorsa en az miktarda kaydir; ustteki yapiskan
       baslik ve alttaki mobil navigasyon cubugu hesaba katilir. */
    function revealPanel() {
      var header = document.querySelector('[data-v2-header]');
      var bar = document.querySelector('[data-v2-bottombar]');
      var pad = 14;
      var top = (header ? header.getBoundingClientRect().height : 0) + pad;
      var bottom =
        (window.innerHeight || document.documentElement.clientHeight) -
        (bar && getComputedStyle(bar).display !== 'none' ? bar.getBoundingClientRect().height : 0) -
        pad;

      var rect = panel.getBoundingClientRect();

      /* Kart ekranda GORUNUYORSA hic kaydirma. Once "bir kismi kirpiliyorsa
         kaydir" diyordu; kart neredeyse tamamen ekrandayken bile sayfa
         zipliyordu ve her yetenek tiklamasinda rahatsiz ediyordu.
         Artik yalnizca kart tamamen ekran disindaysa kaydiriyoruz.
         8px tolerans: bir kirinti gorunuyor diye kaydirmayi atlamayalim. */
      var visible = Math.min(rect.bottom, bottom) - Math.max(rect.top, top);
      if (visible > 8) return;

      var delta;
      if (rect.height <= bottom - top) {
        delta = rect.bottom > bottom ? rect.bottom - bottom : rect.top - top;
      } else {
        delta = rect.top - top;
      }
      if (Math.abs(delta) < 4) return;

      if (window.scrollBy && 'scrollBehavior' in document.documentElement.style) {
        window.scrollBy({ top: delta, behavior: reduced ? 'auto' : 'smooth' });
      } else {
        window.scrollTo(0, window.pageYOffset + delta);
      }
    }

    /* ---------------- Konumlandırma ---------------- */
    function layout() {
      var size = stage.clientWidth;
      var boxH = stage.clientHeight;
      if (!size || !boxH) return;

      var cx = size / 2;
      var cy = boxH / 2;
      /* İç halka: cihazdan çıkan yetenekler. Dış halka: ayrı satılan
         Buddy'ler — kesikli ve okra, "kutudan çıkmıyor" demek için. */
      var R = size * 0.29;
      var R2 = size * 0.455;
      /* Cihaz gorseli CSS'te width:30% -> yariçapi tam 0.15.
         Baglanti cizgileri gorselin kenarindan baslasin diye ayni deger. */
      var deviceR = size * 0.15;

      lines.setAttribute('viewBox', '0 0 ' + size + ' ' + boxH);
      lines.innerHTML = '';

      /* Yalnizca IC cember cizilir. Dis halkanin kesikli cemberi kaldirildi;
         Buddy'ler yine R2 yaricapinda duruyor ama ayri satildiklarini artik
         kesikli hap cercevesi, okra rengi ve kesikli baglanti cizgisi soyluyor. */
      var c = document.createElementNS(SVG_NS, 'circle');
      c.setAttribute('cx', cx);
      c.setAttribute('cy', cy);
      c.setAttribute('r', R);
      c.setAttribute('fill', 'none');
      c.setAttribute('stroke', 'rgba(22,24,29,.12)');
      c.setAttribute('stroke-width', '1.2');
      lines.appendChild(c);

      items.forEach(function (item, index) {
        var node = nodes[index];
        if (!node) return;

        var eco = item.kind === 'buddy';

        var radius = eco ? R2 : R;
        var rad = (Number(item.angle) || 0) * (Math.PI / 180);
        var x = cx + radius * Math.cos(rad);
        var y = cy + radius * Math.sin(rad);
        node.style.left = x + 'px';
        node.style.top = y + 'px';

        /* Bağlantı çizgisi: yerleşik yetenek cihaza bağlanır, Buddy ise iç
           halkaya — "cihaza takılınca çalışır" bunu anlatıyor. */
        var from = eco ? R : deviceR;
        var line = document.createElementNS(SVG_NS, 'line');
        line.setAttribute('x1', cx + from * Math.cos(rad));
        line.setAttribute('y1', cy + from * Math.sin(rad));

        var hw = node.offsetWidth / 2;
        var hh = node.offsetHeight / 2;
        var ca = Math.abs(Math.cos(rad));
        var sa = Math.abs(Math.sin(rad));
        var edge = Math.min(ca > 0.001 ? hw / ca : 1e6, sa > 0.001 ? hh / sa : 1e6);

        line.setAttribute('x2', x - (edge + 3) * Math.cos(rad));
        line.setAttribute('y2', y - (edge + 3) * Math.sin(rad));
        line.setAttribute('stroke', eco ? 'rgba(35,115,189,.45)' : 'rgba(22,24,29,.2)');
        line.setAttribute('stroke-width', '1.4');
        line.setAttribute('stroke-linecap', 'round');
        if (eco) line.setAttribute('stroke-dasharray', '5 5');
        lines.appendChild(line);
      });
    }

    /* ---------------- Otomatik tur ---------------- */
    function nodePos(index) {
      var el = nodes[index];
      if (!el) return null;
      var x = parseFloat(el.style.left);
      var y = parseFloat(el.style.top);
      if (!isNaN(x) && !isNaN(y)) return { x: x, y: y };

      var rect = el.getBoundingClientRect();
      var base = stage.getBoundingClientRect();
      if (!rect.width) return null;
      return { x: rect.left - base.left + rect.width / 2, y: rect.top - base.top + rect.height / 2 };
    }

    function tourStep() {
      if (!cursor || !playing) return;
      tourIdx = (tourIdx + 1) % items.length;
      var pos = nodePos(tourIdx);
      if (!pos) {
        stopTour();
        return;
      }

      cursor.style.transform = 'translate(' + (pos.x - 4) + 'px,' + (pos.y - 3) + 'px)';
      at(1250, function () {
        cursor.classList.add('is-tap');
        select(tourIdx);
      });
      at(1520, function () {
        cursor.classList.remove('is-tap');
      });
      at(4600, tourStep); /* kart okunacak kadar bekle, sonra ilerle */
    }

    function playTour() {
      if (!cursor || playing) return;
      var first = nodePos((tourIdx + 1) % items.length);
      if (!first) return;
      playing = true;

      /* geçişi kapatıp ilk durağın biraz uzağına ışınla, sonra aç */
      cursor.classList.remove('is-ready', 'is-tap', 'is-show');
      cursor.style.transform = 'translate(' + (first.x + 78) + 'px,' + (first.y + 66) + 'px)';
      void cursor.offsetWidth;
      cursor.classList.add('is-ready', 'is-show');
      at(80, tourStep);
    }

    /* Otomatik tur (imleç yetenekleri tek tek gezer) bölüm ayarına bağlı.
       Kapalıysa imleç hiç gösterilmez; ziyaretçi düğümlere kendisi dokunur. */
    var autoplay = data.autoplay !== false;

    if (autoplay && cursor && !reduced && window.IntersectionObserver && stageWrap) {
      /* Yeniden kurulma bölüm ekrandan TAMAMEN çıkınca olur; kart okunurken
         yapılan küçük kaydırmalar turu yeniden tetiklemesin. */
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
              if (armed && !touched) {
                armed = false;
                at(420, playTour);
              }
            } else if (!entry.isIntersecting) {
              armed = true;
              stopTour();
            }
          });
        },
        { threshold: [0, 0.4] }
      ).observe(stageWrap);
    } else if (cursor) {
      cursor.style.display = 'none';
    }

    /* ---------------- Deneyim penceresi ---------------- */
    var modal = document.querySelector('[data-v2-demo-modal]');
    var modalHome = modal ? modal.parentNode : null;
    var mTitle = modal && modal.querySelector('[data-v2-demo-title]');
    var mSub = modal && modal.querySelector('[data-v2-demo-sub]');
    var mBody = modal && modal.querySelector('[data-v2-demo-body]');

    var dIdx = -1;
    /* Seçenek ve ışık durumu artık DOM'da (is-on sınıfı / hidden); burada
       yalnızca ışığın anlık hâli tutuluyor. */
    var dLamp = false;
    var dAudio = null;
    var dScrollY = 0;
    var dLocked = false;

    function demoDeviceState(on) {
      var el = mBody.querySelector('.v2-dm__dev');
      if (el) el.classList.toggle('is-on', !!on);
    }

    function demoStop() {
      if (dAudio) {
        dAudio.pause();
        dAudio = null;
      }
      var playingEl = mBody.querySelector('.v2-dm__play.is-on');
      if (playingEl) playingEl.classList.remove('is-on');
      var playingVideo = mBody.querySelector('video');
      if (playingVideo && !playingVideo.paused) playingVideo.pause();
      demoDeviceState(false);
    }

    function demoDevice() {
      var item = items[dIdx];
      var eco = item && item.kind === 'buddy' ? ' eco' : '';
      var img = data.device
        ? '<img src="' + esc(data.device) + '" alt="" onerror="this.style.visibility=\'hidden\'">'
        : '';
      return (
        '<div class="v2-dm__dev' +
        eco +
        '"><span class="ring"></span><span class="ring"></span><span class="ring"></span>' +
        img +
        '<span class="state"><i></i>' +
        esc(t.playing) +
        '</span></div>'
      );
    }

    /* ---------------- Deneyin penceresi ----------------
       İçerik artık JS'te üretilmiyor: yeteneğin alt blokları (v2-demo-*)
       işaretlemeyi sunucuda basıyor, burada pencereye kopyalanıp bağlanıyor.

       Tek istisna yerleşim: "Soru" bloğunda seçenekler hem çip hem cevap
       basar. Liquid tarafını düz tutmak için çipleri üstte tek satıra,
       cevapları altta tek alana burada topluyoruz. */
    function demoReflowChoices(item) {
      Array.prototype.forEach.call(mBody.querySelectorAll('[data-demo-choice]'), function (choice) {
        var opts = Array.prototype.slice.call(choice.querySelectorAll('[data-demo-option]'));
        if (!opts.length) return;

        var chips = document.createElement('div');
        chips.className = 'v2-dm__chips';
        var outs = document.createElement('div');
        outs.className = 'v2-dm__outs';

        opts.forEach(function (opt) {
          var chip = opt.querySelector('[data-demo-opt]');
          var answer = opt.querySelector('[data-demo-answer]');
          if (chip) {
            if (item.kind === 'buddy') chip.classList.add('eco');
            chips.appendChild(chip);
          }
          if (answer) outs.appendChild(answer);
          if (opt.parentNode) opt.parentNode.removeChild(opt);
        });

        var empty = document.createElement('div');
        empty.className = 'v2-dm__out is-empty';
        empty.setAttribute('data-demo-empty', '');
        empty.textContent = choice.getAttribute('data-empty') || t.emptyState || '';
        outs.appendChild(empty);

        choice.appendChild(chips);
        choice.appendChild(outs);
      });
    }

    /* Gece ışığı düğmesindeki cihaz görseli bölüm ayarından gelir; blok onu
       bilmediği için butonu burada dolduruyoruz. */
    function demoFillLamps() {
      if (!data.device) return;
      Array.prototype.forEach.call(mBody.querySelectorAll('[data-demo-lamp] .b'), function (btn) {
        if (btn.querySelector('img')) return;
        var img = document.createElement('img');
        img.src = data.device;
        img.alt = '';
        img.onerror = function () {
          img.style.visibility = 'hidden';
        };
        btn.appendChild(img);
      });
    }

    function demoMount() {
      var item = items[dIdx];
      if (!item) return;
      mBody.innerHTML = (item.showDevice ? demoDevice() : '') + item.demoHtml;
      demoReflowChoices(item);
      demoFillLamps();
    }

    function demoOpen(index) {
      if (!modal || !items[index] || !items[index].demoHtml) return;
      dIdx = index;

      mTitle.textContent = items[index].name;
      mSub.textContent = [items[index].subtitle, items[index].age].filter(Boolean).join(' · ');
      demoMount();

      /* Tarayıcı tam ekranında yalnızca tam ekran öğesi çizilir; pencereyi
         oraya taşımazsak hiç görünmez. Kapanışta eski yerine döner. */
      var fsEl = document.fullscreenElement;
      if (fsEl && !fsEl.contains(modal)) fsEl.appendChild(modal);

      if (!document.body.classList.contains('v2-fs-lock')) {
        dScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.top = -dScrollY + 'px';
        document.body.classList.add('v2-fs-lock');
        dLocked = true;
      }
      modal.classList.add('is-open');
    }

    function demoClose() {
      if (!modal) return;
      demoStop();
      modal.classList.remove('is-open');
      mBody.innerHTML = '';
      if (dLocked) {
        document.body.classList.remove('v2-fs-lock');
        document.body.style.top = '';
        window.scrollTo(0, dScrollY);
        dLocked = false;
      }
      if (modalHome && modal.parentNode !== modalHome) modalHome.appendChild(modal);
    }

    panel.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('[data-v2-demo]') : null;
      if (!btn) return;
      touched = true;
      stopTour();
      demoOpen(parseInt(btn.getAttribute('data-v2-demo'), 10));
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-v2-demo-close]')) demoClose();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) demoClose();
      });

      mBody.addEventListener('click', function (event) {
        var playBtn = event.target.closest('.v2-dm__play button');
        if (playBtn) {
          var wrap = playBtn.parentNode;
          var file = wrap.getAttribute('data-file');
          if (wrap.classList.contains('is-on')) {
            demoStop();
            return;
          }
          demoStop();
          wrap.classList.add('is-on');
          demoDeviceState(true);

          var audio = new Audio(file);
          dAudio = audio;
          audio.onended = function () {
            wrap.classList.remove('is-on');
            demoDeviceState(false);
          };
          audio.onerror = function () {
            wrap.classList.remove('is-on');
            demoDeviceState(false);
            var next = wrap.nextElementSibling;
            if (!next || next.className !== 'v2-dm__file') {
              wrap.insertAdjacentHTML(
                'afterend',
                '<div class="v2-dm__file">' + esc(t.audioMissing) + ' ' + esc(file) + '</div>'
              );
            }
          };
          var promise = audio.play();
          if (promise && promise.catch) {
            promise.catch(function () {
              audio.onerror();
            });
          }
          return;
        }

        /* Soru seçeneği: aynı sorunun diğer cevaplarını kapat, bunu aç. */
        var optBtn = event.target.closest('[data-demo-opt]');
        if (optBtn) {
          demoStop();
          var choice = optBtn.closest('[data-demo-choice]');
          if (!choice) return;
          var chips = choice.querySelectorAll('[data-demo-opt]');
          var answers = choice.querySelectorAll('[data-demo-answer]');
          var picked = -1;
          Array.prototype.forEach.call(chips, function (chip, k) {
            var on = chip === optBtn;
            if (on) picked = k;
            chip.classList.remove('is-on', 'is-wrong');
            if (!on) return;
            /* Bilmece kipinde en az bir seçenek doğru işaretliyse yanlış
               seçim kırmızı gösterilir; hiçbiri işaretli değilse quiz değil. */
            var hasCorrect = choice.querySelector('[data-demo-opt][data-correct]');
            chip.classList.add(hasCorrect && !chip.hasAttribute('data-correct') ? 'is-wrong' : 'is-on');
          });
          Array.prototype.forEach.call(answers, function (answer, k) {
            answer.hidden = k !== picked;
          });
          var emptyEl = choice.querySelector('[data-demo-empty]');
          if (emptyEl) emptyEl.hidden = picked >= 0;
          return;
        }

        var lampBtn = event.target.closest('[data-lamp]');
        if (lampBtn) {
          var wrap = lampBtn.closest('[data-demo-lamp]');
          var lampEl = lampBtn.closest('.v2-dm__lamp');
          if (!wrap || !lampEl) return;
          dLamp = !lampEl.classList.contains('is-on');
          lampEl.classList.toggle('is-on', dLamp);
          var label = wrap.querySelector('[data-lamp-text]');
          if (label) {
            label.textContent = dLamp
              ? wrap.getAttribute('data-on-text') || ''
              : wrap.getAttribute('data-off-text') || '';
          }
        }
      });
    }

    /* ---------------- Tam ekran ---------------- */
    var fsBtn = section.querySelector('[data-v2-orbit-fs]');
    if (fsBtn) {
      var native = !!section.requestFullscreen; /* iOS Safari'de yok → CSS kaplaması */
      var fsY = 0;
      var lbl = fsBtn.querySelector('.v2-orbit__fs-lbl');

      var paint = function (on) {
        fsBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (lbl) lbl.textContent = on ? lbl.dataset.labelExit : lbl.dataset.labelEnter;
        setTimeout(layout, 60);
      };

      /* Kaplama modunda bölüm position:fixed olur, yani akıştan çıkar;
         gövdeyi kilitleyip çıkışta tam olarak aynı noktaya dönüyoruz. */
      var overlayOpen = function () {
        fsY = window.scrollY || window.pageYOffset || 0;
        document.body.style.top = -fsY + 'px';
        document.body.classList.add('v2-fs-lock');
        section.classList.add('is-fs');
        paint(true);
      };

      var overlayClose = function () {
        section.classList.remove('is-fs');
        document.body.classList.remove('v2-fs-lock');
        document.body.style.top = '';
        window.scrollTo(0, fsY);
        paint(false);
      };

      fsBtn.addEventListener('click', function () {
        if (native) {
          if (document.fullscreenElement === section) {
            document.exitFullscreen();
          } else {
            fsY = window.scrollY || window.pageYOffset || 0;
            section.requestFullscreen().catch(function () {
              native = false;
              overlayOpen();
            });
          }
        } else if (section.classList.contains('is-fs')) {
          overlayClose();
        } else {
          overlayOpen();
        }
      });

      document.addEventListener('fullscreenchange', function () {
        if (!native) return;
        var on = document.fullscreenElement === section;
        paint(on);
        if (!on) {
          if (modalHome && modal && modal.parentNode !== modalHome) modalHome.appendChild(modal);
          /* bazı tarayıcılar çıkışta kaydırmayı oynatıyor — geri koy */
          setTimeout(function () {
            window.scrollTo(0, fsY);
          }, 20);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && section.classList.contains('is-fs')) overlayClose();
      });
    }

    /* ---------------- Kurulum ---------------- */
    layout();
    window.addEventListener('resize', layout, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(layout).observe(stage);

    var initial = Math.min(Math.max(parseInt(data.initial, 10) || 0, 0), items.length - 1);
    select(initial);

    /* ---------------- Tema editörü ----------------
       Yetenek ve demo blokları ekranda görünmeyen bir kapta duruyor (yalnızca
       veri taşıyorlar). Editörde bir blok seçilince Shopify o görünmez öğeye
       kaydırmaya çalışıyor, sayfa alakasız bir yere atlıyor ve düzenlenen şey
       görünmüyordu. Burada seçimi yakalayıp ilgili yeteneği çemberde seçiyor,
       demo bloklarındaysa "Deneyin" penceresini açıyoruz: mağaza sahibi tam
       olarak düzenlediği şeye bakıyor. */
    function capIndexOf(node) {
      if (!node || !node.closest) return -1;
      var capEl = node.closest('[data-v2-cap]');
      if (!capEl) return -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el === capEl) return i;
      }
      return -1;
    }

    document.addEventListener('shopify:block:select', function (event) {
      var index = capIndexOf(event.target);
      if (index < 0) return;

      stopTour();
      touched = true;
      armed = false;
      select(index);

      /* Demo adımı seçildiyse pencereyi aç; yeteneğin kendisi seçildiyse
         kartı göster. event.target === yetenek kabı ise demo değildir. */
      var isDemoBlock = event.target !== items[index].el;
      if (isDemoBlock && items[index].demoHtml) {
        demoOpen(index);
      } else {
        demoClose();
        revealPanel();
      }
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      if (capIndexOf(event.target) < 0) return;
      demoClose();
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-v2-orbit-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
